// LinedSection.jsx
import React, { useMemo } from "react";
import { motion } from "framer-motion";
import styles from "./LinedSection.module.css";

/**
 * Usage:
 * <LinedSection>
 *   <h2>...</h2>
 * </LinedSection>
 */
export default function LinedSection({
  children,
  density = 42, // number of rain lines
}) {
  const lines = useMemo(
    () =>
      Array.from({ length: density }).map((_, i) => ({
        id: i,
        // random-ish but stable positions/sizes
        left: `${(i * (100 / density) + (i % 3) * 0.9) % 100}%`,
        height: `${22 + (i % 9) * 9}px`,
        delay: (i % 12) * 0.25,
        duration: 2.8 + (i % 7) * 0.35,
        opacity: 0.25 + (i % 5) * 0.1,
      })),
    [density]
  );

  return (
    <section className={styles.wrap}>
      {/* grid */}
      <div className={styles.grid} />

      {/* vignette */}
      <div className={styles.vignette} />

      {/* falling glow lines */}
      <div className={styles.rain} aria-hidden="true">
        {lines.map((l) => (
          <motion.span
            key={l.id}
            className={styles.rainLine}
            style={{ left: l.left, height: l.height, opacity: l.opacity }}
            initial={{ y: -140 }}
            animate={{ y: ["-140px", "110vh"] }}
            transition={{
              duration: l.duration,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 0.8,
              delay: l.delay,
            }}
          />
        ))}
      </div>

      <div className={styles.content}>{children}</div>
    </section>
  );
}